import React from "react";
import { Button, FormControl, Modal, ControlLabel, Alert } from "react-bootstrap";
import immutable from "immutable";
import context from "./../../lib/context.js";
import ajax from "./../../lib/ajax.js";
import moment from "moment";
import SpecialBillForm from "./specialbill-form.jsx";
import FreetimePicker from "./free-timepicker.jsx";

const FROM_MEAL_BREAK = "From Meal Break";
const TO_MEAL_BREAK = "To Meal Break";

export default class LogWorkForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLogWorkDlg: false,
            mode: "add",
            work: {},
            saveWorkErrors: null,
            quarterRounding: false,
            disableSave: false,
            disableSpecialBill: false,
            initialTaskId: null,
            enableTimeInRounding: false,
            enableTimeOutRounding: false
        };

        this.openNew = this.openNew.bind(this);
        this.openUpdate = this.openUpdate.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onSave = this.onSave.bind(this);
        this.getTimeList = this.getTimeList.bind(this);
        this.shouldDisableTask = this.shouldDisableTask.bind(this);
        this.toggleDisablingTask = this.toggleDisablingTask.bind(this);
        this._updateInOutDate = this._updateInOutDate.bind(this);
        this._shouldEnableRounding = this._shouldEnableRounding.bind(this);

        console.log(props);
    }

    _shouldEnableRounding(reason) {
        if (!this.props.vm.quarterRounding) return false;
        else return !this.props.vm.disableMealBreakRounding || (reason !== FROM_MEAL_BREAK && reason !== TO_MEAL_BREAK);
    }

    openUpdate(timecardLineDetailId) {
        const self = this;
        const clone = immutable.fromJS(this.state);
        clone.showLogWorkDlg = true;
        clone.mode = "update";
        clone.disableSpecialBill = false;

        ajax.api()
            .get(`get-logged-work/${timecardLineDetailId}`)
            .then(res => {
                console.log(res);
                clone.work = res.data;
                clone.work.timecardLineDetailId = timecardLineDetailId;
                clone.initialTaskId = clone.work.taskId;
                clone.quarterRounding = this.props.vm.quarterRounding;
                clone.enableTimeInRounding = this._shouldEnableRounding(clone.work.inReason);
                clone.enableTimeOutRounding = this._shouldEnableRounding(clone.work.outReason);
                if (!clone.work.outDate) {
                    clone.work.outDate = clone.work.inDate;
                }

                self.setState(clone);
                console.log(clone, this.props);
            })
            .catch(function (err) {
                console.log(err);
            });

    }

    openNew() {
        const clone = immutable.fromJS(this.state);
        clone.showLogWorkDlg = true;
        clone.mode = "add";
        clone.work = {};
        clone.disableSpecialBill = false;
        clone.enableTimeInRounding = this.props.vm.quarterRounding;
        clone.enableTimeOutRounding = this.props.vm.quarterRounding;
        console.log(clone, this.props);

        this.setState(clone);
    }

    onSave(inputs) {
        const self = this;
        self.state.work.specialBill = inputs.specialBill.getSpecialBill();
        self.state.work.timecardId = this.props.vm.timecardId;
        const request = immutable.fromJS(self.state.work).toJS();
        request.specialBill = inputs.specialBill.getSpecialBillWithRequired();
        request.noSpecialBillUpdate = false;

        context.message({
            show: true,
            type: "loading",
            message: "Logging work. Please wait..."
        });

        if (this.state.mode === "add") {
            ajax.api()
                .post("log-work", request)
                .then(function (res) {
                    let clone = immutable.fromJS(self.state).toJS();
                    clone.saveWorkErrors = null;
                    clone.showLogWorkDlg = false;
                    self.setState(clone);
                    if (self.props.onLogWork) self.props.onLogWork(res);
                    else {
                        context.message({
                            show: false,
                        });
                    }
                })
                .catch(function (err) {
                    let map = immutable.fromJS(self.state);
                    let data = err.response.data;
                    let errors = null;
                    let errorItems = [];
                    if (data.ClassName === "ActionPortal.ValidationException") {
                        for (let key in data.Data.summary.validationResults) {
                            errorItems.push((
                                <li key={key}>{data.Data.summary.validationResults[key]}</li>
                            ));
                        }
                        errors = (<ul>
                            {errorItems}
                        </ul>);
                    } else {
                        errors = data.exceptionMessage || data.message;
                    }
                    let clone = map.toJS();
                    clone.saveWorkErrors = errors;
                    self.setState(clone);
                    context.message({
                        show: false,
                    });
                });
        } else if (this.state.mode === "update") {
            request.noSpecialBillUpdate = self.shouldDisableTask() || this.state.disableSpecialBill == true;
            ajax.api()
                .put(`log-work/${self.state.work.timecardLineDetailId}`, request)
                .then(function (res) {
                    let clone = immutable.fromJS(self.state).toJS();
                    clone.saveWorkErrors = null;
                    clone.showLogWorkDlg = false;
                    self.setState(clone);
                    if (self.props.onLogWork) self.props.onLogWork(res);
                    else {
                        context.message({
                            show: false,
                        });
                    }
                })
                .catch(function (err) {
                    let map = immutable.fromJS(self.state);
                    let data = err.response.data;
                    let errors = null;
                    let errorItems = [];
                    if (data.ClassName === "ActionPortal.ValidationException") {
                        for (let key in data.Data.summary.validationResults) {
                            errorItems.push((
                                <li key={key}>{data.Data.summary.validationResults[key]}</li>
                            ));
                        }
                        errors = (<ul>
                            {errorItems}
                        </ul>);
                    } else {
                        errors = data.exceptionMessage || data.message;
                    }
                    let clone = map.toJS();
                    clone.saveWorkErrors = errors;
                    console.log(clone);
                    self.setState(clone);
                    context.message({
                        show: false,
                    });
                });
        }
    }

    onClose() {
        this.setState(immutable.fromJS(this.state)
            .mergeDeep({ showLogWorkDlg: false, saveWorkErrors: null })
            .toJS());
    }

    getTimeList() {
        let timeList = [];
        let m = moment();
        m.hour(0);
        m.minute(0);
        m.second(0);
        let now = moment();
        let selectedTime = "0:00";
        let outTime = "0:15";
        for (let i = 0; i < 96; i++) {
            let d = moment.duration(now - m).asMinutes();
            if (d >= 0 && d <= 15) {
                selectedTime = m.format("H:mm");
                outTime = moment(m).add(15, "m").format("H:mm");
            }
            timeList.push(
                <option key={m.format("H:mm")} value={m.format("H:mm")}>{m.format("h:mm A")}</option>
            );
            m.add(15, "m");
        }

        return {
            list: timeList,
            selectedTime: selectedTime,
            selectedOutTime: outTime
        };
    }

    shouldDisableTask() {
        const state = this.state;
        const work = state.work;
        const vm = this.props.vm;

        if (!vm.placementTasks || vm.placementTasks.length == 0) return true;
        else if (!work.taskId) {
            if (work.taskCode == null) return false;
            else return true;
        }
        else {
            for (let i = 0; i < vm.placementTasks.length; i++) {
                if (vm.placementTasks[i].placementTaskId == work.taskId) return false;
            }
            return true;
        }
    }

    toggleDisablingTask(val) {

        this.setState(
            immutable.fromJS(this.state)
                .mergeDeep({
                    disableSpecialBill: val
                }).toJS()
        );
    }

    _updateInOutDate(inputs, strWeekEnding) {
        const self = this;
        try {
            const timeIn = moment(`${moment(self.state.work.inDate).format('YYYY-MM-DD')} ${self.state.work.inTime}`);
            const outDate = moment(self.state.work.inDate);
            const timeOut = moment(`${moment(outDate).format('YYYY-MM-DD')} ${self.state.work.outTime}`);
            const weekEnding = moment(strWeekEnding);

            if (timeOut.isSameOrBefore(timeIn) && timeOut.isSameOrBefore(weekEnding, "day")) {
                outDate.add("day", 1);
            }
            const value = outDate.format('YYYY-MM-DDT00:00:00');
            inputs.outDate.value = value;
            self.state.work.outDate = value;
        } catch (err) {
            console.debug(err);
        }
    }

    render() {
        const self = this;
        const vm = self.props.vm;
        const openRole = self.props.role;
        const timeList = this.getTimeList();
        const inputs = {};
        const work = self.state.work;
        const rfcVisible = openRole == 'payroll-admin' || openRole == 'supervisor' ? '' : 'ap-hidden';
        const strWeekEnding = vm.weekDays ? vm.weekDays[vm.weekDays.length - 1] : "";

        let logWorkError = null;
        if (self.state.saveWorkErrors) {
            logWorkError = (<Alert bsStyle="danger">{self.state.saveWorkErrors}</Alert>);
        }

        let timeIn = null, timeOut = null;
        if (this.state.enableTimeInRounding) {
            timeIn = <FormControl componentClass="select" defaultValue={work.inTime ? work.inTime :
                function () { work.inTime = timeList.selectedTime; return work.inTime; }()}
                onChange={(evt) => {
                    self.state.work.inTime = evt.target.value;
                    this._updateInOutDate(inputs, strWeekEnding);
                }}
                inputRef={node => inputs.inTime = node}>
                {immutable.fromJS(timeList.list).toJS()}
            </FormControl>;
        } else {
            timeIn = <FreetimePicker ref="timeIn" onChange={() => {
                self.state.work.inTime = self.refs.timeIn.getValue();
                this._updateInOutDate(inputs, strWeekEnding);
            }} time={work.inTime ? work.inTime : function () { work.inTime = timeList.selectedTime; return work.inTime; }()} />;
        }

        if (this.state.enableTimeOutRounding) {
            timeOut = <FormControl componentClass="select" defaultValue={work.outTime ? work.outTime :
                function () { work.outTime = timeList.selectedOutTime; return work.outTime; }()}
                inputRef={node => inputs.outTime = node}
                onChange={(evt) => {
                    self.state.work.outTime = evt.target.value;
                    this._updateInOutDate(inputs, strWeekEnding);
                }}>
                {immutable.fromJS(timeList.list).toJS()}
            </FormControl>;
        } else {
            timeOut = <FreetimePicker ref="timeOut" onChange={() => {
                self.state.work.outTime = self.refs.timeOut.getValue();
                this._updateInOutDate(inputs, strWeekEnding);
            }} time={work.outTime ? work.outTime : function () { work.outTime = timeList.selectedOutTime; return work.outTime; }()} />;
        }

        // if (vm.quarterRounding) {
        //     timeIn = <FormControl componentClass="select" defaultValue={work.inTime ? work.inTime :
        //         function () { work.inTime = timeList.selectedTime; return work.inTime; }()}
        //         onChange={(evt) => {
        //             self.state.work.inTime = evt.target.value;
        //             this._updateInOutDate(inputs, strWeekEnding);
        //         }}
        //         inputRef={node => inputs.inTime = node}>
        //         {immutable.fromJS(timeList.list).toJS()}
        //     </FormControl>;
        //     timeOut = <FormControl componentClass="select" defaultValue={work.outTime ? work.outTime :
        //         function () { work.outTime = timeList.selectedOutTime; return work.outTime; }()}
        //         inputRef={node => inputs.outTime = node}
        //         onChange={(evt) => {
        //             self.state.work.outTime = evt.target.value;
        //             this._updateInOutDate(inputs, strWeekEnding);
        //         }}>
        //         {immutable.fromJS(timeList.list).toJS()}
        //     </FormControl>;
        // } else {
        //     timeIn = <FreetimePicker ref="timeIn" onChange={() => {
        //         self.state.work.inTime = self.refs.timeIn.getValue();
        //         this._updateInOutDate(inputs, strWeekEnding);
        //     }}
        //         time={work.inTime ? work.inTime : function () { work.inTime = timeList.selectedTime; return work.inTime; }()} />;
        //     timeOut = <FreetimePicker ref="timeOut" onChange={() => {
        //         self.state.work.outTime = self.refs.timeOut.getValue();
        //         this._updateInOutDate(inputs, strWeekEnding);
        //     }}
        //         time={work.outTime ? work.outTime : function () { work.outTime = timeList.selectedOutTime; return work.outTime; }()} />;
        // }

        let disableSpecialBill = self.shouldDisableTask();
        const nextWeekFirstDay = moment(vm.weekDays[vm.weekDays.length - 1]).add(1, "d");

        return (
            <Modal show={this.state.showLogWorkDlg} >
                <Modal.Header >
                    <Modal.Title>Add/Edit Timeclock</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        <div className={`row ap-border-color-lightgray ${rfcVisible}`}>
                            <div className="col-md-12">
                                <ControlLabel>Reason for change<span className="ap-color-red"> *</span></ControlLabel>
                                <FormControl componentClass="textarea" rows="2"
                                    onChange={(evt) => self.state.work.reasonForChange = evt.target.value} defaultValue={work.reasonForChange} />
                            </div>
                        </div>
                        <div className="row ap-border-color-lightgray">
                            <div className="col-md-4">
                                <ControlLabel>Date<span className="ap-color-red"> *</span></ControlLabel>
                                <FormControl componentClass="select" onChange={(evt) => {
                                    self.state.work.inDate = evt.target.value;
                                    inputs.outDate.value = evt.target.value;
                                    self.state.work.outDate = evt.target.value;
                                    this._updateInOutDate(inputs, strWeekEnding);
                                }} defaultValue={work.inDate} disabled={this.state.mode != "add"}>
                                    <option key="" value=""></option>
                                    {vm.weekDays.map(wd => <option key={wd} value={wd}>{moment(wd).format("ddd, MMM DD")}</option>)}
                                    {
                                        !self.state.work.inReason || self.state.work.inReason === "To Work" ?
                                            null :
                                            <option key={nextWeekFirstDay.format("YYYY-MM-DDT00:00:00")} value={nextWeekFirstDay.format("YYYY-MM-DDT00:00:00")}>{nextWeekFirstDay.format("ddd, MMM DD")}</option>
                                    }
                                </FormControl>
                            </div>
                            <div className="col-md-4">
                                <ControlLabel>In<span className="ap-color-red"> *</span></ControlLabel>
                                {timeIn}
                            </div>
                            <div className="col-md-4">
                                <ControlLabel>Reason<span className="ap-color-red"> *</span></ControlLabel>
                                <FormControl componentClass="select" onChange={(evt) => {
                                    const clone = Object.assign({}, self.state);
                                    clone.work.inReason = evt.target.value;
                                    clone.enableTimeInRounding = this._shouldEnableRounding(evt.target.value);
                                    this.setState(clone);
                                }}
                                    defaultValue={work.inReason}>
                                    <option key="" value=""></option>
                                    {vm.inReasons.map(r => <option key={r.key} value={r.key}>{r.value}</option>)}
                                </FormControl>
                            </div>
                        </div>
                        <div className="row ap-border-color-lightgray">
                            <div className="col-md-4">
                                <ControlLabel>Date<span className="ap-color-red"> *</span></ControlLabel>
                                <FormControl componentClass="select" onChange={(evt) => self.state.work.outDate = evt.target.value}
                                    inputRef={node => inputs.outDate = node} defaultValue={work.outDate} disabled={true}>
                                    <option key="" value=""></option>
                                    {vm.weekDays.map(wd => <option key={wd} value={wd}>{moment(wd).format("ddd, MMM DD")}</option>)}
                                    <option key={nextWeekFirstDay.format("YYYY-MM-DDT00:00:00")} value={nextWeekFirstDay.format("YYYY-MM-DDT00:00:00")}>{nextWeekFirstDay.format("ddd, MMM DD")}</option>
                                </FormControl>
                            </div>
                            <div className="col-md-4">
                                <ControlLabel>Out<span className="ap-color-red"> *</span></ControlLabel>
                                {timeOut}
                            </div>
                            <div className="col-md-4">
                                <ControlLabel>Reason<span className="ap-color-red"> *</span></ControlLabel>
                                <FormControl componentClass="select" onChange={(evt) => {
                                    const clone = Object.assign({}, self.state);
                                    clone.work.outReason = evt.target.value
                                    clone.enableTimeOutRounding = this._shouldEnableRounding(evt.target.value);
                                    this.setState(clone);
                                }}
                                    defaultValue={work.outReason}>
                                    <option key="" value=""></option>
                                    {vm.outReasons.map(r => <option key={r.key} value={r.key}>{r.value}</option>)}
                                </FormControl>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <hr />
                            </div>
                            <div className="col-sm-12 col-md-2">
                                <ControlLabel>Task <span className="ap-color-red"> *</span></ControlLabel>
                            </div>
                            <div className="col-sm-12 col-md-10">
                                {!disableSpecialBill ?
                                    <FormControl componentClass="select" onChange={(evt) => {
                                        self.state.work.taskId = evt.target.value;
                                        self.setState(immutable.fromJS(self.state).mergeDeep({ disableSave: true }).toJS());
                                        setTimeout(inputs.specialBill.updateTaskId(evt.target.value, false,
                                            () => {
                                                setTimeout(() => {
                                                    self.setState(immutable.fromJS(self.state).mergeDeep({
                                                        disableSave: false
                                                    }).toJS());
                                                }, 1);
                                            }), 1);
                                    }} defaultValue={work.taskId}>
                                        <option key="" value="">Please select...</option>
                                        {vm.placementTasks.map(pt => <option key={pt.placementTaskId} value={pt.placementTaskId}>{pt.taskValue}</option>)}
                                    </FormControl> :
                                    <FormControl defaultValue={work.taskCode} disabled={true} />
                                }

                            </div>
                            <div className="col-sm-12 col-md-2">
                                <ControlLabel>Note</ControlLabel>
                            </div>
                            <div className="col-sm-12 col-md-10">
                                <FormControl componentClass="textarea" placeholder="Note" rows="4"
                                    onChange={(evt) => self.state.work.note = evt.target.value} defaultValue={work.note} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <SpecialBillForm ref={node => inputs.specialBill = node} taskId={work.taskId} specialBill={work.specialBill}
                                    disableControls={disableSpecialBill} toggleTaskCallback={this.toggleDisablingTask} initialTaskId={self.state.initialTaskId} />
                            </div>
                            <div className="col-md-12">
                                {logWorkError}
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-4 ap-top-margined">
                                <Button className="btn-info ap-fullsize" onClick={() => this.onSave(inputs)} disabled={self.state.disableSave}>Save</Button>
                            </div>
                            <div className="col-md-4 ap-top-margined"></div>
                            <div className="col-md-4 ap-top-margined">
                                <Button className="btn-info ap-fullsize" onClick={this.onClose}>Cancel</Button>
                            </div>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}